export class ProvinceModel {
  id: number;
  key: string;
  name: string;
  countryCode: string;
}
